<template>
  <div id="products">
    <Header />

    <TitleComponent text="Productos" />

    <section v-if="isMobile()">
      <div
        class="row category-controls m-bottom-xs p-bottom-half-xs filter-row"
      >
        <div class="fix-filter">
          <div
            v-if="selectedCategory !== undefined"
            class="category-border"
            @click="selectCategory(undefined)"
          >
            <a class="category-name">{{ selectedCategory }}</a>
            <img src="../assets/X.svg" width="20px" height="20px" />
          </div>
        </div>
        <div>
          <a
            href="#"
            class="js-toggle-mobile-filters js-fullscreen-modal-open visible-xs col-xs-4 m-top p-top-half p-left-none text-right btn-link-secondary"
            data-modal-url="modal-fullscreen-filters"
            @click="openFilterModal()"
          >
            <h5 class="filter">Filtrar</h5>
            <svg
              class="svg-inline--fa svg-text-fill"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z"
              ></path>
            </svg>
          </a>
        </div>
      </div>

      <ProductMasonry :products="getProducts" />
    </section>
    <section v-else>
      <v-container>
        <v-layout wrap>
          <v-flex xs2>
            <div
              v-if="selectedCategory !== undefined"
              class="category-border"
              @click="selectCategory(undefined)"
            >
              <a class="category-name">{{ selectedCategory }}</a>
              <img src="../assets/X.svg" width="20px" height="20px" />
            </div>
            <h5>Categorías:</h5>
            <div v-for="(category, index) in categories" :key="index">
              <h5 @click="selectCategory(category.name)" class="category-name">
                {{ category.name }}
              </h5>
            </div>
          </v-flex>
          <v-flex xs10 class="pages-content">
            <ProductMasonry :products="getProducts" />
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <ModalFilterMobile
      v-if="showFilterMobile"
      :categories="categories"
      @close="closeModal"
      @onSelectedCategory="onSelectedCategory"
    />
    <WppComponent />
    <Footer />
  </div>
</template>

<script>
import { db } from "../firebase";
import firebase from "firebase/firebase";
import mobile_detection from "../mixins/mobile_detection";
import user_detection from "../mixins/user_detection";
import TitleComponent from "../components/TitleComponent";
import ProductMasonry from "../components/ProductMasonry";
import WppComponent from "../components/WppComponent";
import ModalFilterMobile from "../components/ModalFilterMobile";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default {
  mixins: [mobile_detection, user_detection],
  name: "Products",
  firebase: {
    products: db.ref("products"),
    categories: db.ref("categories"),
  },
  data() {
    return {
      products: [],
      categories: [],
      selectedCategory: "",
      showFilterMobile: false,
    };
  },
  mounted() {
    this.selectedCategory = this.$route.query.c;
    this.isUserAdmin();
  },
  computed: {
    getProducts() {
      if (this.selectedCategory === undefined) {
        return this.products;
      } else {
        var array = [];

        this.products.forEach((prod) => {
          if (prod.category == this.selectedCategory) {
            array.push(prod);
          }
        });

        return array;
      }
    },
  },
  methods: {
    onSelectedCategory(category) {
      this.selectCategory(category);
    },
    selectCategory(name) {
      this.selectedCategory = name;
      this.closeFilterModal();
    },
    closeFilterModal() {
      this.showFilterMobile = false;
    },
    openFilterModal() {
      this.showFilterMobile = true;
    },
  },
  components: {
    TitleComponent,
    ProductMasonry,
    WppComponent,
    ModalFilterMobile,
    Footer,
    Header,
  },
};
</script>

<style scoped>
.filter-row {
  margin-top: -15px !important;
  margin-bottom: 10px;
}
.fix-filter {
  width: 60%;
  align-self: center;
}
.category-border {
  max-width: max-content;
  border-style: solid;
  background: rgba(95, 106, 121, 0.06);
  border-radius: 10px;
  padding: 4px;
  cursor: pointer;
}
.filter {
  display: -webkit-inline-box;
  color: black;
}
.category-name {
  margin-right: 5px;
  font-weight: normal !important;
  font-size: medium;
  padding: 7px;
  cursor: pointer;
}
.selected-category {
  color: blue;
  font-weight: bold !important;
}
.all-categories {
  margin-bottom: 30px;
}

.filter-content {
  background: rgba(95, 106, 121, 0.06);
  align-self: center;
}
.white {
  background: white;
  color: white;
}
.wrap {
  justify-content: center;
}
.row {
  margin-left: 0;
  margin-right: 0;
  justify-content: center;
  align-self: center;
  margin-top: -30px;
}
.item {
  height: max-content;
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Open Sans";
  letter-spacing: 2px;
}
h4,
.h4 {
  font-size: 18px;
}
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.layout {
  display: -webkit-box !important;
}

.btn-link-secondary {
  text-transform: uppercase;
  font-weight: bold;
}
.font-medium,
.btn-link-secondary {
  font-size: 16px;
}
.text-right {
  text-align: right !important;
}
.p-left-none {
  padding-left: 0 !important;
}
svg:not(:root) {
  overflow: hidden;
}
.svg-text-fill {
  fill: #5f6a79;
}
.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

@media only screen and (min-width: 360px) and (max-width: 450px) {
  .visible-xs {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Products.vue